import  Link  from 'next/link'
import { Card, Col } from 'react-bootstrap'

const Advisors = () => (
    [
        {
            image: "../../../images/home/dr-daggy.png",
            name: "Dr. Bruce Daggy",
            desc: "Dr. Bruce Daggy PhD is a research scientist and educator focused on improving the healthcare system via the effective use of nutrition & lifestyle approaches.",
            id: "dr-daggy"
        },
        {
            image: "../../../images/home/dr-westerdahl.png",
            name: "Dr. John Westerdahl",
            desc: "Dr. John Westerdahl, PhD, MPH, RDN, CNS, FAND, is an internationally recognized authority in the fields of food, nutrition, and wellness. He is a Registered Dietitian Nutritionist, Certified Nutrition Specialist, Master Herbalist, Board Certified Anti-Aging Health Practitioner, Health Scientist, and Health Educator.",
            id: "dr-westerdahl"
        },
        {
            image: "../../../images/home/rusty-ost.png",
            name: "Rusty Ost RPh",
            desc: "Rusty Ost is a weed and seeds pharmacist and has extensive training in herbs and phytomedicinal products. He did post-graduate work on designing dosage forms and delivery systems & he also owned a chain of retail pharmacies.",
            id: "dr-ost"
        }
    ].map((data, idx) => (
        <Col md={4} key={idx}>
            <Card className="border-0 mb-3">
                <div className="rounded-circle overflow-hidden mx-auto img-fluid" style={{ width: '70%' }}><Card.Img variant="top" src={data.image}/></div>
                <Card.Body className="px-2">
                    <Card.Title><strong>{data.name}</strong></Card.Title>
                    <Card.Text className="text-left">{data.desc}</Card.Text>
                    <Link href={`/nutritional-advisors#${data.id}`}><a className="text-green h7"><u>Complete Bio</u></a></Link>
                </Card.Body>
            </Card>
        </Col>
    ))
);

export default Advisors